import { RoleType } from '@sdk/authentication/types';

import { SYSTEM_ROLES } from '@web/constants';

export default function getUserRoleName(role: RoleType): string {
  const userRole = SYSTEM_ROLES.find((r) => r.name === role);

  return userRole?.displayname || role;
}
